export default __webpack_public_path__ + "static/media/wrench-solid.a2ec29e1.svg";